module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.readonly,
      "label": "Demo ID",
      "rules": _vm.demoIdRules,
      "hide-details": "auto"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5442278d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/DemoId.vue
// module id = 1897
// module chunks = 0